import { useGateValue } from '@statsig/react-bindings';

const useAuroraRollout = () => {
  return useGateValue('aurora_rollout');
};

export default useAuroraRollout;
